// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getReturnOrderURLLinks } from '@/return-order/api/get-return-order-url-links';
import { returnOrderURLLinksQueryKey } from '@/return-order/query-keys';
import { useQuery } from '@tanstack/react-query';

interface UseReturnOrderURLLinksOptions {
  /** The key of the return order to fetch URL links for */
  returnOrderKey: string;
}

export function useReturnOrderURLLinks(options: UseReturnOrderURLLinksOptions) {
  const { data, ...query } = useQuery({
    queryKey: returnOrderURLLinksQueryKey(options.returnOrderKey),
    queryFn: () => getReturnOrderURLLinks(options.returnOrderKey),
  });

  return {
    ...query,
    urlLinks: data?.data ?? [],
  };
}
